import React, { PropsWithChildren } from 'react';
import { StyledSearchWrapper } from './styles';

interface ISearchWrapper extends PropsWithChildren<{
  padding?: string | undefined;
  margin?: string | undefined;
}> {}

const SearchWrapper = ({ children, padding = '', margin = '' }: ISearchWrapper) => (
  <StyledSearchWrapper padding={padding} margin={margin}>
    {children}
  </StyledSearchWrapper>
);

export { SearchWrapper };
